'use strict';/* global define */define('modules/feedback/directives/avg-analytics/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope"];
function controller($scope){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.previous=$scope.previous;ctrl.current=$scope.current;ctrl.hasDataFn=hasData;ctrl.isBetterFn=isBetter;var isAvgAnalyticsDefined=$scope.$watch(function(){return $scope.previous!==undefined&&$scope.current!==undefined;},function(isPreviousAndCurrentDefined){if(isPreviousAndCurrentDefined){ctrl.previous=$scope.previous;ctrl.current=$scope.current;ctrl.hasData=hasData();ctrl.isBetter=isBetter();isAvgAnalyticsDefined();}});// ---
/**
     * Check if all the required data is available in order
     * to calculate the avg analytics change
     *
     * Note: The label should be always provided to the template
     *
     * @return {Boolean} - If we have all the required information or not
     *
     * @tested
     */function hasData(){if(ctrl.previous&&ctrl.current){ctrl.label=ctrl.current.label;return true;}else if(ctrl.previous||ctrl.current){ctrl.label=ctrl.current?ctrl.current.label:ctrl.previous.label;return false;}else{ctrl.label='-';return false;}}/**
     * Calculate the average analytics change
     *
     * @return {Boolean|String} - Indication if the metrics are better
     *                            or no change
     *
     * @tested
     */function isBetter(){if(ctrl.previous&&ctrl.current){return ctrl.previous.level===ctrl.current.level?'noChange':ctrl.current.level>ctrl.previous.level;}}}module.exports=controller;});
